// ListInvoiceModal.jsx  (PURE JSX VERSION)

import React, { useEffect, useState } from "react";
import { X, Eye } from "react-feather";
import { apiService } from "../../../../services/apiService.ts";
import InvoiceModal from "./InvoiceModal"; // Will be rewritten in STEP 4

export default function ListInvoiceModal({ isOpen, onClose, accountId }) {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);

  const [errorMessage, setErrorMessage] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);

  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  // Helper to parse values from { parsedValue } or raw numbers
  const parseValue = (v) => {
    if (v == null) return 0;
    if (typeof v === "object" && "parsedValue" in v) {
      const n = Number(v.parsedValue);
      return isNaN(n) ? 0 : n;
    }
    const n = Number(v);
    return isNaN(n) ? 0 : n;
  };

  // -------------------------
  // LOAD INVOICES
  // -------------------------
  const loadInvoices = async () => {
    if (!accountId) return;

    setLoading(true);
    try {
      const res = await apiService.getAccountInvoices(accountId);
      if (res.Success && res.Data) {
        setInvoices(res.Data);
      } else {
        setInvoices([]);
      }
    } catch (err) {
      console.error("Invoice load error:", err);
      setInvoices([]);
    }
    setLoading(false);
  };

 useEffect(() => {
  if (isOpen) {
    setErrorMessage(null);
    loadInvoices();
  }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [isOpen]);

  // -------------------------
  // VIEW EXISTING INVOICE
  // -------------------------
  const handleViewInvoice = async (invoiceId) => {
    const invoice = invoices.find((i) => i.InvoiceHeaderID === invoiceId);
    if (!invoice) return;

    const excl = parseValue(invoice.ExclTotal);
    const vat = parseValue(invoice.VatTotal);
    const incl = parseValue(invoice.InclTotal);

    const bookingRef = invoice.BookingReference || invoice.InvoiceNo || "";

    const invoiceData = {
      company: "Blue Safari Seychelles",
      logoUrl: "/images/blue-safari-logo.png",
      vatNo: "831 519 929",
      guestName: invoice.PartyName || "Guest",
      address: "P.O Box 378, Mahé, Seychelles",
      bookingInfo: {
        confNo: bookingRef,
        crsNo: invoice.FK_AccountID || "—",
        date: new Date(invoice.DateCreated || Date.now()).toLocaleDateString(),
        time: new Date(invoice.DateCreated || Date.now()).toLocaleTimeString(),
        voucherNo: invoice.InvoiceNo,
        invoiceNo: invoice.InvoiceNo,
        folioNo: invoice.InvoiceNo,
        arNo:
          "AR-" +
          (invoice.InvoiceNo || "")
            .replace(/\D/g, "")
            .padStart(3, "0"),
      },
      stayInfo: {
        guests: 2,
        arrival: new Date(invoice.DateCreated || Date.now()).toLocaleDateString(),
        departure: new Date(invoice.DateCreated || Date.now()).toLocaleDateString(),
        roomNo: "{21}",
        roomType: "{AILBB}",
        cashier: "{SYSTEM}",
      },
      items: [
        {
          date: new Date(invoice.DateCreated || Date.now()).toLocaleDateString(),
          description: `Booking Reference ${bookingRef}`,
          amount: excl,
        },
      ],
      balance: excl,
      vat,
      eqBalanceEur: incl / 16.4,
      eqBalanceUsd: incl / 14.1,
      phone: "+248 422 97 00",
      email: "reservations@bluesafari.com",
      website: "www.bluesafari.com",
      addressFooter: "P.O Box 378, Mahé, Seychelles",
    };

    setSelectedInvoice(invoiceData);
    setInvoiceModalOpen(true);
  };

  // -------------------------
  // GENERATE NEW INVOICE
  // -------------------------
  const handleGenerateInvoice = async () => {
    if (!accountId) return;
    setIsGenerating(true);
    setErrorMessage(null);

    try {
      const res = await apiService.generateAccountInvoice(accountId);

      if (!res.Success || !res.Data) {
        setErrorMessage("Failed to generate invoice");
        setIsGenerating(false);
        return;
      }

      const data = res.Data;

      const excl = Number(data.InvoiceTotalExcl || 0);
      const vat = Number(data.InvoiceTotalVat || 0);
      const incl = Number(
        typeof data.InvoiceTotalIncl === "object"
          ? data.InvoiceTotalIncl.parsedValue || 0
          : data.InvoiceTotalIncl || 0
      );

      const items = [];
      if (Array.isArray(data.Tabs)) {
        data.Tabs.forEach((tab) => {
          if (Array.isArray(tab.TabLines)) {
            tab.TabLines.forEach((line) => {
              const amount =
                typeof line.LineTotalIncl === "object"
                  ? Number(line.LineTotalIncl.parsedValue || 0)
                  : Number(line.LineTotalIncl || 0);

              items.push({
                date: new Date(
                  tab.ClosedDate || Date.now()
                ).toLocaleDateString(),
                description: line.Product || "Item",
                amount,
              });
            });
          }
        });
      }

      const invoiceData = {
        company: "Blue Safari Seychelles",
        logoUrl: "/images/blue-safari-logo.png",
        vatNo: "831 519 929",
        guestName: data.PartyName || "Guest",
        address: "P.O Box 378, Mahé, Seychelles",
        bookingInfo: {
          confNo: data.BookingReference || "—",
          crsNo: data.AccountName || "—",
          date: new Date().toLocaleDateString(),
          time: new Date().toLocaleTimeString(),
          voucherNo: data.InvoiceNo,
          invoiceNo: data.InvoiceNo,
          folioNo: data.InvoiceNo,
          arNo:
            "AR-" +
            (data.InvoiceNo || "")
              .replace(/\D/g, "")
              .padStart(3, "0"),
        },
        stayInfo: {
          guests: 2,
          arrival: new Date().toLocaleDateString(),
          departure: new Date().toLocaleDateString(),
          roomNo: "{21}",
          roomType: "{AILBB}",
          cashier: "{SYSTEM}",
        },
        items,
        balance: excl,
        vat,
        eqBalanceEur: incl / 16.4,
        eqBalanceUsd: incl / 14.1,
        phone: "+248 422 97 00",
        email: "reservations@bluesafari.com",
        website: "www.bluesafari.com",
        addressFooter: "P.O Box 378, Mahé, Seychelles",
      };

      setSelectedInvoice(invoiceData);
      setInvoiceModalOpen(true);
    } catch (err) {
      console.error("Generate Invoice Error:", err);
      setErrorMessage("Unexpected error generating invoice");
    }

    setIsGenerating(false);
  };

  if (!isOpen) return null;

  // ----------------------------------------------------------------------
  // MAIN MODAL
  // ----------------------------------------------------------------------
  return (
    <>
      <div
        className="modal fade show d-block pos-modal"
        style={{ background: "rgba(0,0,0,0.45)", zIndex: 30000 }}
      >
        <div className="modal-dialog modal-xl modal-dialog-centered">
          <div className="modal-content rounded-4 shadow-lg">

            {/* HEADER */}
            <div className="modal-header border-0 pb-2">
              <h5 className="modal-title fw-semibold">Account Invoices</h5>
              <button className="btn btn-light" onClick={onClose}>
                <X size={18} />
              </button>
            </div>

            {/* BODY */}
            <div className="modal-body">

              {/* ACTION BAR */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="fw-semibold mb-0">Invoices</h6>

                <button
                  onClick={handleGenerateInvoice}
                  disabled={isGenerating}
                  className="btn btn-primary"
                >
                  {isGenerating ? "Generating…" : "Generate Invoice"}
                </button>
              </div>

              {errorMessage && (
                <div className="alert alert-danger d-flex justify-content-between">
                  <div>{errorMessage}</div>
                  <button
                    className="btn-close"
                    onClick={() => setErrorMessage(null)}
                  />
                </div>
              )}

              {/* TABLE */}
              <div className="table-responsive border rounded" style={{ maxHeight: "400px" }}>
                {loading ? (
                  <div className="text-center py-4 text-muted">Loading…</div>
                ) : (
                  <table className="table table-sm table-hover">
                    <thead className="table-light">
                      <tr>
                        <th>Invoice No</th>
                        <th className="text-end">Excl Total</th>
                        <th className="text-end">VAT</th>
                        <th className="text-end">Incl Total</th>
                        <th className="text-center">Status</th>
                        <th className="text-center">Actions</th>
                      </tr>
                    </thead>

                    <tbody>
                      {invoices.map((inv) => {
                        const excl = parseValue(inv.ExclTotal);
                        const vat = parseValue(inv.VatTotal);
                        const incl = parseValue(inv.InclTotal);

                        const active = inv.IsDiscarded === false;

                        return (
                          <tr
                            key={inv.InvoiceHeaderID}
                            className={active ? "table-success" : ""}
                          >
                            <td>{inv.InvoiceNo}</td>
                            <td className="text-end">{excl.toFixed(2)}</td>
                            <td className="text-end">{vat.toFixed(2)}</td>
                            <td className="text-end">{incl.toFixed(2)}</td>

                            <td className="text-center">
                              <span
                                className={
                                  active
                                    ? "badge bg-success"
                                    : "badge bg-secondary"
                                }
                              >
                                {active ? "Active" : "Discarded"}
                              </span>
                            </td>

                            <td className="text-center">
                              <button
                                className="btn btn-dark btn-sm"
                                onClick={() =>
                                  handleViewInvoice(inv.InvoiceHeaderID)
                                }
                              >
                                <Eye size={14} />
                              </button>
                            </td>
                          </tr>
                        );
                      })}

                      {!loading && invoices.length === 0 && (
                        <tr>
                          <td colSpan="6" className="text-center py-4 text-muted">
                            No invoices found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>
            </div>

            {/* FOOTER */}
            <div className="modal-footer border-0 pt-0">
              <button className="btn btn-primary px-4" onClick={onClose}>
                Close
              </button>
            </div>

          </div>
        </div>
      </div>

      {/* ------------------------------------------------------- */}
      {/* INVOICE MODAL — WILL BE REWRITTEN IN STEP 4 */}
      {/* ------------------------------------------------------- */}
      {invoiceModalOpen && selectedInvoice && (
        <InvoiceModal
          isOpen={invoiceModalOpen}
          onClose={() => setInvoiceModalOpen(false)}
          invoiceData={selectedInvoice}
        />
      )}
    </>
  );
}
